import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import { WebEngage, GA, PGAD } from "../../../integrations";
import { ZodiacIcon } from "../../atoms/icon";
import BreadCrumb from "../story/story-templates/shared/breadcrumbs";
import ResponsiveImageWithFallback from "../../atoms/responsive-image-with-fallback";
import styles from "./styles.m.css";
import { DfpAd } from "../../atoms/dfp-ad";
import Navbar from "../../atoms/secondary-menu";
import { PAGE_TYPE } from "../../../constants";
import { VikatanCollectionResponsive } from "../../rows/ad-free";

const getZodiacHref = (slug, peyarchiType) => {
  const storySlug = slug.split("/").pop();
  return `/horoscope/${peyarchiType}/${storySlug}`;
};

const GenZodiacList = (collectionItems, zodiacsData, peyarchiType) => {
  const stories = collectionItems.map(item => item.story);
  const signs = stories.map(({ slug }, index) => {
    const zodiac = zodiacsData[index] || {};
    return (
      <Link
        aria-label="Zodiac Sign"
        className={styles["zodiac-element"]}
        href={getZodiacHref(slug, peyarchiType)}
        key={zodiac.type}
      >
        <ZodiacIcon
          type={zodiac.type}
          className={styles["zodiac-element__icon"]}
          hoverClassName={styles["show-on-hover"]}
        />
        <h3 className={styles["headline"]}>{zodiac.display_name}</h3>
      </Link>
    );
  });
  return <div className={styles["zodiac-grid"]}>{signs}</div>;
};

export const GurupeyarchiLandingPage = ({ data, config }) => {
  React.useEffect(() => {
    WebEngage.registerPageView();
    GA.registerPageView(PAGE_TYPE.GURUPEYARCHI_PAGE, { collection: data.collection });
    PGAD.loadScript();
  }, []);
  const items = get(data, ["collection", "items"], null);
  if (!items) {
    return null;
  }
  const metadata = get(data, ["collection", "metadata"], {});
  const name = get(data, ["collection", "name"], "");
  const summary = get(data, ["collection", "summary"], "");
  const subMenu = get(data, ["menuData"], {});
  const zodiacsData = get(data, ["zodiacs"], []);
  const peyarchiType = get(data, ["peyarchiType"], "gurupeyarchi");
  const ad = (
    <div className={styles["ad-container"]}>
      <DfpAd adtype="Half_Page" placement="gurupeyarchi-landing" className={styles["gurupeyarchi-mobile-ad"]} />
    </div>
  );
  const content = (
    <React.Fragment>
      <h1 className={`${styles["headline"]}`}>{name}</h1>
      <div className={styles["summary"]}>{summary}</div>
    </React.Fragment>
  );
  return (
    <div className={`${styles["page"]} main-page`}>
      <div />
      <div>
        {subMenu ? (
          <Navbar
            menuGroup={subMenu}
            slug={"spiritual"}
            className={`${styles["submenu"]} ${"container-full-mobile"}`}
            communityColor={subMenu.bgColor}
          />
        ) : null}
        <div className={"container"}>
          <BreadCrumb config={config} collection={data.collection} />
          <div className={styles["base"]}>
            <div className={styles["image-container"]}>
              <ResponsiveImageWithFallback
                className={styles["image-wrapper"]}
                metadata={get(metadata, ["cover-image", "cover-image-metadata"])}
                slug={get(metadata, ["cover-image", "cover-image-s3-key"])}
                imgParams={{ auto: ["format", "compress"] }}
                sources={[
                  {
                    aspectRatio: [5, 7],
                    defaultWidth: 400,
                    widths: [400, 600, 800],
                    sizes: "(min-width: 767px) 40vw"
                  }
                ]}
              />
            </div>
            <div className={styles["content"]}>
              {content}
              {GenZodiacList(items, zodiacsData, peyarchiType)}
            </div>
            <div className={styles["ad-wrapper"]}>
              <div className={styles["ad-content"]}>{ad}</div>
            </div>
          </div>

          <div className={styles["gurupeyarchi-ad"]}>
            <VikatanCollectionResponsive
              DesktopAdtype="Vikatan_Desktop_SP_BTF_728x90"
              MobileAdtype="Vikatan_Mobile_SP_TOP_320x100"
              placement="bundle"
            />
          </div>
        </div>
      </div>
      <div />
    </div>
  );
};

GurupeyarchiLandingPage.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.shape({
      items: PropTypes.arrayOf(
        PropTypes.shape({
          story: PropTypes.shape({
            slug: PropTypes.string
          })
        })
      ),
      name: PropTypes.string,
      summary: PropTypes.string,
      metadata: PropTypes.shape({
        "cover-image": PropTypes.shape({
          "cover-image-metadata": PropTypes.object,
          "cover-image-s3-key": PropTypes.string
        })
      })
    }),
    menubarData: PropTypes.shape(Navbar.propTypes),
    peyarchiType: PropTypes.string
  }),
  config: PropTypes.shape({
    contentInsightsId: PropTypes.string
  })
};

export default GurupeyarchiLandingPage;
